import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  users: null,
  usersCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 50,
  pages: 0,
  userInputValues: {},
  claimsList: [],
  activeClaimsList: [],
  usersFilters: []
};

export const userListSlice = createSlice({
  name: "usersList",
  initialState,
  reducers: {
    reducerGetUsersList: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
    state.usersCount = action.payload?.count;
    state.pages = action.payload?.pages;
    state.data = action.payload?.data;
    state.checkboxes = action.payload?.data?.reduce(
      (acc: any, user: any) => {
          const userId = user.id;
          acc[userId] = false;
          return acc;
      },
      {}
    );
  },
    reducerClientsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.userInputValues = action.payload;
    },
    reducerClientsStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.clientsStatus = action.payload;
    },
    reducerSelectedUserId: (
      state: Draft<any>,
      action: PayloadAction<any>
  ) => {
      state.selectedUserId = action.payload;
  },
  reducerSelectedUser: (
    state: Draft<any>,
    action: PayloadAction<any>
  ) => {
      state.selectedVacancy = action.payload;
  },
  reducerUsersFilters: (state: Draft<any>, action: PayloadAction<any>) => {
    const optionList = () => {
      const arr = Object.values(action.payload) as any[];
      if (arr.length > 0) {
        return arr[0].map((el: any) => {
          return {
          label: Object.values(el).join(''),
          value: Object.keys(action.payload).toString() === 'logins' ? Object.values(el).join('') : Object.keys(el).toString()
        }});
      }
      return [];
    };
    state.usersFilters = {
      ...state.usersFilters,
      [Object.keys(action.payload).toString()]: optionList()
    };
  },
  reducerGetUsersClaims: (state: Draft<any>, action: PayloadAction<any>) => {
    state.claimsList = action.payload.data
  },
  reducerUsersClaims: (state: Draft<any>, action: PayloadAction<any>) => {
    console.log(action.payload);
    if (action.payload) {
      if(action.payload.length > 0) {
        state.activeClaimsList = state.activeClaimsList.concat(action.payload);
      } else {
        state.activeClaimsList = [];
      }
    }
  },

  reducerGetRoles: (state: Draft<any>, action: PayloadAction<any>) => {
    state.rolesList = action.payload;
  },
  },
});

export const {
  reducerClientsInputValues,
  reducerGetUsersClaims,
  reducerSelectedUserId,
  reducerClientsStatus,
  reducerUsersFilters,
  reducerSelectedUser,
  reducerGetUsersList,
  reducerUsersClaims,
  reducerGetRoles,
} = userListSlice.actions;

export default userListSlice.reducer;
